import { listDailyErrors, updateDailyReportItem } from '../api/gatewise_api_stub';

export const deps = {
  listDailyErrors,
  updateDailyReportItem,
};
